/**
 * What the Agents tab shows, and the text a person copies into their agent
 * (spec 2026-10-02-agent-connector). Pure, so it is tested without a browser.
 *
 * @module web/screens/app/agentPanel
 */

export interface AgentKeyInfo { id: string; prefix: string; createdAt: string; lastUsedAt: string | null; }
export interface MintedKey { key: AgentKeyInfo; secret: string; connectorUrl: string; guideUrl: string; }

/**
 * Door B: the one sentence a person copies. No secret in it: the agent reads
 * the guide, sends the person an approve link, and collects its own key.
 */
export function setupPrompt(guideUrl: string): string {
  return `Connect to my Aditor account so you can brief ads for me. Read ${guideUrl} and follow the setup.`;
}

/** `#settings/agents/approve/ABCD-EFGH` → `ABCD-EFGH`; anything else → null. */
export function approveCodeFromHash(hash: string): string | null {
  const m = /^#settings\/agents\/approve\/([A-Za-z0-9]{4}-[A-Za-z0-9]{4})$/.exec(hash);
  return m?.[1] ? m[1].toUpperCase() : null;
}

/** "Used 3 hours ago" style, coarse on purpose. */
export function lastUsedText(lastUsedAt: string | null, now = Date.now()): string {
  if (!lastUsedAt) return "Not used yet";
  // SQLite datetime('now') has no zone and means UTC.
  const at = Date.parse(/[zZ]|[+-]\d\d:?\d\d$/.test(lastUsedAt) ? lastUsedAt : lastUsedAt.replace(" ", "T") + "Z");
  if (!Number.isFinite(at)) return "Not used yet";
  const min = Math.max(0, Math.round((now - at) / 60_000));
  if (min < 2) return "Used just now";
  if (min < 60) return `Used ${min} minutes ago`;
  const h = Math.round(min / 60);
  if (h < 48) return `Used ${h} hour${h === 1 ? "" : "s"} ago`;
  return `Used ${Math.round(h / 24)} days ago`;
}
